module.exports = __webpack_public_path__ + "img/1F6AF.a830f1f7.svg";